import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"


  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyC_FZtX6lDCDbpqIn_r7h1eFfk9qUc4KG0",
    authDomain: "fishmarket-39331.firebaseapp.com",
    databaseURL: "https://fishmarket-39331.firebaseio.com",
    projectId: "fishmarket-39331",
    storageBucket: "fishmarket-39331.appspot.com",
    messagingSenderId: "565311601756"
  };
  if( !firebase.apps.length ) {
    firebase.initializeApp(config);
  }

  const DB = firebase.firestore()

  DB.settings({})

  const STORAGE = firebase.storage().ref();

  const auth = firebase.auth()
  export {
    DB,
    auth,
    STORAGE
  }



// WEBPACK FOOTER //
// ./src/firebase.js